import { Divider, ScrollArea, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { AllocationTypeFilter } from '../../filters/allocation-type/allocation-type-filter';
import { TaskTypeFilter } from '../../header/task-type-filter';
import { useScrollToTop } from '../../process-analysis.hooks';
import { Text } from '../../../../ui-library/typography/typography';
import { FiltersContent } from './filters-content';
import { FiltersHeader } from './filters-header';
import { PointsFilter } from './points-filter';

export const Filters = () => {
  const { t } = useTranslation();
  const scrollAreaRef = useScrollToTop();
  const agentViewMode = useProcessAnalysisStore((state) => state.agentViewMode);

  // The Task Type and Story Points filters only scope task-level metrics
  // (cycle time). The Usage view shows session/event and adoption metrics that
  // are not task-scoped, so they are hidden there to avoid implying they have
  // any effect.
  const showCycleTimeFilters = agentViewMode === 'cycle_time';

  return (
    <Stack gap="md" h="100%">
      <FiltersHeader />
      <Divider />
      <AllocationTypeFilter />
      {showCycleTimeFilters && (
        <>
          <Stack gap={8}>
            <Text size="small" weight="bold">
              {t('process_analysis.filters.task_type', { defaultValue: 'Task Type' })}
            </Text>
            <TaskTypeFilter />
          </Stack>
          <PointsFilter />
        </>
      )}
      <Divider />
      <ScrollArea viewportRef={scrollAreaRef} h="100%" scrollbarSize={0} style={{ flex: 1 }}>
        <FiltersContent />
      </ScrollArea>
    </Stack>
  );
};
